import { Element } from '@svgdotjs/svg.js';

import { formatColor } from './formatColor';

const getFillFromElementStyle = (element: Element): string | null => {
    const style = element.attr('style') as string;

    if (!style) {
        return null;
    }

    const fillColor = style.match('/(fill:[^;]+;?)/')?.shift();

    if (!fillColor || fillColor === 'none') {
        return null;
    }

    return formatColor(fillColor);
};

const getFillFromElementAttribute = (element: Element): string | null => {
    const attributeFillColor = element.attr('fill');

    if (attributeFillColor === 'none') {
        return null;
    }

    return formatColor(attributeFillColor);
};

export const getFillFromElement = (element: Element): string | null => {
    const styleFillColor = getFillFromElementStyle(element);

    if (styleFillColor) {
        return styleFillColor;
    }

    return getFillFromElementAttribute(element);
};
